import { Empty } from "antd"
import { DisplayProjects, IProject } from "../types/project.type"
import ProjectsList from "./ProjectsList"
import ProjectsTable from "./ProjectsTable"

const Projects: React.FC<{ projects: IProject[]; displayType: DisplayProjects }> = ({
  projects,
  displayType,
}) => {
  if (projects.length === 0) {
    return <Empty description="Create your first project" />
  }

  return displayType === DisplayProjects.TABLE ? (
    <ProjectsTable projects={projects} />
  ) : (
    <ProjectsList projects={projects} />
  )
}

export default Projects
